module.exports = __webpack_public_path__ + "static/media/xls.f0da48b2.svg";